import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'vw-calendar-months-header',
    imports: [TranslateModule, CommonModule],
    templateUrl: './calendar-months-header.component.html',
    styleUrl: './calendar-months-header.component.scss'
})
export class CalendarMonthsHeaderComponent {
  @Input() currentMonth: number;
}
